import firebase from "firebase/compat/app";
import { collection, getCountFromServer, query } from "firebase/firestore";
import { FC } from "react";
import db, { newDB } from "../../../db";
import Button from "../../../styles/components/Button";

const OrdersTab: FC = () => {
  const updateOrderMarketplaceCreatedAt = async () => {
    return await db
      .collection("orders")
      .get()
      .then((snap) => {
        if (snap.docs.length > 0) {
          snap.docs.forEach(async (doc) => {
            const dataOrder = doc.data();
            if (dataOrder.marketpalceOrderCreatedAt) {
              await doc.ref.set(
                {
                  marketplaceOrderCreatedAt:
                    dataOrder.marketpalceOrderCreatedAt,
                  marketpalceOrderCreatedAt:
                    firebase.firestore.FieldValue.delete(),
                },
                { merge: true }
              );
            }

            console.log(doc.data());
          });
        }
      });
  };

  return (
    <>
      <Button
        className="btn btn-lg btn-primary fw-bolder me-4"
        onClick={async () => {
          const q = query(collection(newDB, "orders"));
          const countOrder = (await getCountFromServer(q)).data().count;

          console.log("Count Order", countOrder);
        }}
      >
        Try Count
      </Button>
      <Button
        className="btn btn-lg btn-primary fw-bolder me-4"
        onClick={async () => {
          await updateOrderMarketplaceCreatedAt();
        }}
      >
        Update Order marketplaceCreatedAt
      </Button>
    </>
  );
};

export default OrdersTab;
